export class TipologiaErogazione{
    id:number;
    descrizione:string;  
    titolo:string;  
}